<section class="jtp-title" >
  <h1 [innerHTML]="'TITLE' | translate"></h1>
  <img *ngIf="isBeta" class="beta-img" src="{{betaTagUrl}}" alt="Beta-version">
</section>
<router-outlet></router-outlet>
